import { toSafeMarkup } from '~/domains/common/utils/toSafeMarkup';

import { Section, SectionContent, SectionGridLabel } from './components';

type LongRulesProps = {
  longRules: string;
  isSidePanel?: boolean;
};

function LongRules({ longRules, isSidePanel }: LongRulesProps) {
  if (!longRules) return null;

  return (
    <Section>
      <SectionContent isSidePanel={isSidePanel}>
        <SectionGridLabel
          isSidePanel={isSidePanel}
          dangerouslySetInnerHTML={{ __html: toSafeMarkup(longRules) }}
        />
      </SectionContent>
    </Section>
  );
}

export default LongRules;

export type { LongRulesProps };
